<template>
  <basic-container>
    <!--搜索栏-->
    <div class="search_group">
      <!-- 第一行 -->
      <div class="search_row">
        <el-date-picker v-model="createTime" class="search_item"
          :disabled-date="disabledDate" clearable value-format="yyyy-MM-dd" type="daterange" start-placeholder="下单开始时间" end-placeholder="下单结束时间"
          size="small" unlink-panels :picker-options="expireTimeOption" />
        <el-date-picker v-model="payTime" class="search_item"
          clearable value-format="yyyy-MM-dd" type="daterange" start-placeholder="支付开始时间" end-placeholder="支付结束时间" size="small" unlink-panels
          :picker-options="expireTimeOption" />
        <el-date-picker v-model="refundTime" class="search_item"
          :disabled-date="disabledDate" clearable value-format="yyyy-MM-dd" type="daterange"
          start-placeholder="退款开始时间" end-placeholder="退款结束时间" size="small" unlink-panels :picker-options="expireTimeOption" />
        <el-input :maxlength="30" v-model="orderNum" class="search_item" size="small" placeholder="订单编号/商户单号/流水..." clearable></el-input>
        <el-input :maxlength="30" v-model="mobile" class="search_item" size="small" placeholder="用户账号" clearable></el-input>
      </div>

      <!-- 第二行 -->
      <div class="search_row">
        <el-select v-model="bussiTypeParams" class="search_item" size="small" multiple collapse-tags clearable filterable placeholder="业务类型">
          <el-option v-for="item in businessTypeList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
        </el-select>
        <el-select v-model="merchantIdParams" class="search_item" size="small" multiple collapse-tags clearable filterable placeholder="收款商户类型">
          <el-option v-for="item in merchantList" :key="item.merchantId" :label="item.merchantName" :value="item.merchantId" />
        </el-select>
        <el-select v-model="payTypeParams" class="search_item" size="small" multiple collapse-tags clearable filterable placeholder="支付方式">
          <el-option v-for="item in payTypeList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
        </el-select>
        <el-select v-model="productIdParams" class="search_item" size="small" multiple collapse-tags clearable filterable placeholder="购买来源">
          <el-option v-for="item in productList" :key="item.id" :label="item.pname" :value="item.id" />
        </el-select>
        <DynamicOption v-model="appids" :placeholder="'请选择渠道'" :singleSelect="false" :params="searchOptions" :size="'small'" class="search_item" />
      </div>

      <!-- 第三行 -->
      <div class="search_row">
        <el-select v-model="orderTypeFilterParams" class="search_item" size="small" multiple collapse-tags clearable filterable placeholder="订单类型">
          <el-option label="普通订单" :value="1"></el-option>
          <el-option label="加购订单" :value="2"></el-option>
        </el-select>
        <el-select v-model="goodsTypeFilterParams" class="search_item" size="small" multiple collapse-tags clearable filterable placeholder="商品类型">
          <el-option label="会员服务" :value="1"></el-option>
          <el-option label="设备服务" :value="4"></el-option>
          <el-option label="激活码" :value="'2,3'"></el-option>
        </el-select>
        <el-select v-model="mtypeIdParams" class="search_item" size="small" multiple collapse-tags clearable filterable placeholder="订单商品类型">
          <el-option v-for="item in serverTypeList" :key="item.id" :label="item.typeName" :value="item.id" />
        </el-select>
        <el-select v-model="goodsIds" class="search_item" size="small" multiple collapse-tags clearable filterable placeholder="会员商品名称">
          <el-option
            v-for="item in goodsNameOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-select v-model="statusParams" class="search_item" size="small" multiple collapse-tags clearable filterable placeholder="订单状态">
          <el-option label="未支付" :value="0"></el-option>
          <el-option label="支付成功" :value="1"></el-option>
          <el-option label="支付失败" :value="2"></el-option>
          <el-option label="已作废" :value="3"></el-option>
        </el-select>
      </div>

      <!-- 第四行 -->
      <div class="search_row">
        <el-select v-model="refundStatusParams" class="search_item" size="small" multiple collapse-tags clearable filterable placeholder="退款状态">
          <el-option label="未申请" :value="0"></el-option>
          <el-option label="待处理" :value="1"></el-option>
          <el-option label="退款失败" :value="2"></el-option>
          <el-option label="已退款" :value="3"></el-option>
          <el-option label="拒绝退款" :value="4"></el-option>
        </el-select>
        <el-select v-model="supplementStatusParams" class="search_item" size="small" multiple collapse-tags clearable filterable placeholder="补单状态">
          <el-option label="未申请" :value="0"></el-option>
          <el-option label="待处理" :value="1"></el-option>
          <el-option label="已补单" :value="2"></el-option>
          <el-option label="已拒绝" :value="3"></el-option>
        </el-select>
        <div class="search_item search_buttons">
          <el-button @click="searchAct" v-auth="'order_search'" icon="el-icon-search" size="small" type="primary">查询</el-button>
          <el-button @click="exportList" v-auth="'order_export'" icon="el-icon-download" size="small" type="primary">导出为Excel</el-button>
        </div>
      </div>
    </div>

    <el-table :cell-style="{ 'text-align': 'center' }" :header-cell-style="{ 'text-align': 'center' }"
      :max-height="tableHeight" v-loading="listLoading" element-loading-text="加载中" border :data="tableData"
      :row-style="{ height: '30px' }">
      <el-table-column prop="id" label="ID" width="80" show-overflow-tooltip></el-table-column>
      <el-table-column prop="bussiTypeName" label="业务类型" width="100" show-overflow-tooltip></el-table-column>
      <el-table-column prop="merchantName" label="收款商户" width="80" show-overflow-tooltip></el-table-column>
      <el-table-column label="订单编号" width="220">
        <template v-slot="scope">
          <span v-clipboard:copy="scope.row.orderNum" @click="copyTip">
            {{ scope.row.orderNum }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="relatedOrderNum" label="关联订单" width="220"></el-table-column>
      <el-table-column prop="orderTitle" label="订单标题" width="220"></el-table-column>
      <el-table-column prop="productName" label="购买来源" width="150"></el-table-column>
      <el-table-column prop="payTradeNo" label="商户单号" width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="transactionId" label="交易流水号" width="300"></el-table-column>
      <el-table-column prop="mtypeName" label="订单商品类型" width="200"></el-table-column>
      <el-table-column prop="goodsName" label="订单商品名称" width="200" show-overflow-tooltip></el-table-column>
      <el-table-column label="商品类型" width="100">
        <template v-slot="scope">{{ getGoodsTypeDesc(scope.row.goodsType) }}</template>
      </el-table-column>
      <el-table-column prop="mobile" label="用户账号" width="150"></el-table-column>
      <el-table-column label="来源渠道" width="400">
        <template v-slot="scope">{{ getSourceChannel(scope.row) }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="下单时间" width="170"></el-table-column>
      <el-table-column prop="price" label="商品原价（元）" width="130"></el-table-column>
      <el-table-column label="商品折扣价（元）" width="140">
        <template v-slot="scope">{{ scope.row.discount > 0 ? scope.row.discount : 0 }}</template>
      </el-table-column>
      <el-table-column label="抵扣金额" width="100">
        <template v-slot="scope">{{ scope.row.deduction > 0 ? scope.row.deduction : 0 }}</template>
      </el-table-column>
      <el-table-column prop="quantity" label="订单数量" width="100"></el-table-column>
      <el-table-column prop="payNum" label="支付金额（元）" width="130" :show-overflow-tooltip="true"></el-table-column>
      <!-- 财务结算金额 -->
      <el-table-column prop="settleAmount" label="财务结算金额" width="130"></el-table-column>
      <el-table-column prop="payTime" label="支付时间" width="170"></el-table-column>
      <el-table-column label="支付方式" width="150">
        <template v-slot="scope">
          {{ getPayTypeDescByPayType(scope.row.payType) || scope.row.payType }}
        </template>
      </el-table-column>
      <el-table-column label="订单状态" width="100">
        <template v-slot="scope">
          {{ getOrderStatusDesc(scope.row.status) || scope.row.status }}
        </template>
      </el-table-column>
      <el-table-column label="订单类型" width="100">
        <template v-slot="scope">
          {{ getGiveStatus(scope.row.isgive) }}
        </template>
      </el-table-column>
      <el-table-column prop="refundTime" label="退款时间" width="170"></el-table-column>
      <el-table-column label="退款状态" width="100">
        <template v-slot="scope">
          {{ getRefundStatusDesc(scope.row.refundStatus) }}
        </template>
      </el-table-column>
      <el-table-column label="补单状态" width="100">
        <template v-slot="scope">
          {{ getSupplementStatusDesc(scope.row.supplementStatus) }}
        </template>
      </el-table-column>
      <el-table-column prop="mark" label="备注" width="100"></el-table-column>

      <!-- 操作栏 按钮 -->
      <el-table-column fixed="right" width="150" label="操作">
        <template slot-scope="scope">
          <el-button @click="openDetail(scope.row, 1)" v-if="canShowRefundButton(scope.row)"
            v-auth="'order_apply_refund'" size="mini" type="warning">
            申请退款
          </el-button>

          <el-button @click="openDetail(scope.row, 4)"
            v-else-if="scope.row.isVoid == 0&&scope.row.status == 1&&(scope.row.refundStatus == null || scope.row.refundStatus == 0 || scope.row.refundStatus == 4)&&(scope.row.payType == 5)&&scope.row.supplementStatus!=1&&scope.row.supplementStatus!=2 "
            v-auth="'order_ios_refund'" size="mini" type="warning">IOS退款
          </el-button>

          <el-button @click="openDetail(scope.row, 3)"
            v-else-if="scope.row.refundStatus == 3 && scope.row.payType == 11" v-auth="'order_doudian_refund_right'"
            size="mini" type="primary">抖店退回权益
          </el-button>
          <el-button @click="openDetail(scope.row, 2)"
            v-else-if="scope.row.status == 0 && (!scope.row.supplementStatus || scope.row.supplementStatus == 0 || scope.row.supplementStatus == 3)"
            v-auth="'order_apply_supplement'" size="mini" type="success">申请补单
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="table_pagination">
      <el-pagination class="app-pagination" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="pageSizeArr" :page-size="pageSize"
        :layout="paginationLayout" :total="totalCount">
      </el-pagination>
    </div>

    <!-- 退款申请 -->
    <el-dialog title="退款申请" :visible.sync="showDetails" append-to-body width="40%">
      <el-form :model="checkItem" size="mini" label-width="110px" label-height="50px">
        <el-form-item label="订单编号">
          {{ checkItem.orderNum }}
        </el-form-item>
        <el-form-item label="用户账户">
          {{ checkItem.mobile }}
          <el-button v-if="checkItem.userChangeMobileRecords && checkItem.userChangeMobileRecords.length > 0"
            @click="showChangeMobileDialog = true" type="text" size="mini" style="margin-left: 70px; color: #409EFF;">
            换绑记录
          </el-button>
        </el-form-item>
        <el-form-item label="支付方式">{{ getPayTypeDescByPayType(checkItem.payType) || checkItem.payType }}</el-form-item>
        <el-form-item label="支付金额">¥ {{ checkItem.payNum }}</el-form-item>
        <el-form-item label="折算金额">¥ {{ getObversionNum(checkItem) }}</el-form-item>
        <el-divider />
        <el-form-item label="退款方式">
          <el-radio-group v-model="refundType">
            <el-radio label="2" size="large">退款且退货</el-radio>
            <el-radio label="1" size="large">退款不退货</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="退款金额">
          <el-input-number v-model="refundPrice" style="width: 150px" placeholder="请输入退款金额" type="number" :min="0"
            :precision="2" :step="0.01" size="small" />
          <el-text
            v-if="refundType === '2' && setMemberType !== '2' && (checkItem.goodsType == 1 || checkItem.goodsType == 4) && checkItem.memberTimelineList"
            style="color: #999999;"
          >
            {{ this.checkItem.maxRefundMoneyText }}
          </el-text>
        </el-form-item>
        <el-form-item label="会员设置" v-if="this.refundType == 2 && (this.checkItem.goodsType == 1 || this.checkItem.goodsType == 4)">
          <el-radio-group v-model="setMemberType">
            <el-radio label="1">系统自动回收</el-radio>
            <el-radio label="2">手动设置到期时间</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="会员类型" v-if="this.setMemberType === '2'">
          <el-text>{{ checkItem.memberName }} 
            <br>有效期：{{ this.checkItem.memberExpire }}
            <br>变更为-到期时间:
          </el-text>
          <el-date-picker v-model="checkItem.newExpireTime" type="date" placeholder="请选择到期时间" size="small"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="退款原因类型">
          <el-radio-group v-model="refundReasonType">
            <el-radio v-for="item in refundReasonTypeList" :key="item.dictKey" :label="item.dictKey"
              :value="item.dictKey" size="large">
              {{ item.dictValue }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="退款原因">
          <el-input type="textarea" :rows="3" :maxlength="150" resize="none" size="large" v-model="refundReason"
            placeholder="请输入文字"></el-input>
        </el-form-item>
      </el-form>

      <!-- 表单按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDetails = false" v-if="checkItem.refundStatus == 1 || checkItem.refundStatus == 2"
          size="small" type="primary" icon="el-icon-circle-check">确定</el-button>
        <el-button @click="changeCheck(2)" v-if="checkItem.refundStatus != 1 && checkItem.refundStatus != 2"
           size="small" type="default" icon="el-icon-circle-close">取消</el-button>
        <el-button @click="changeCheck(3)" v-if="checkItem.refundStatus != 1 && checkItem.refundStatus != 2"
           size="small" type="primary" icon="el-icon-circle-check">确认申请退款</el-button>
      </div>
    </el-dialog>

    <!-- 补单申请 -->
    <el-dialog title="补单申请" :visible.sync="showSupplement" append-to-body width="35%">
      <el-form :model="checkItem" size="mini" label-width="120px">
        <el-form-item label="订单编号">
          {{ checkItem.orderNum }}
        </el-form-item>
        <el-form-item label="用户账户">
          {{ checkItem.mobile }}
        </el-form-item>
        <el-form-item label="订单商品名称">
          {{ checkItem.goodsName }}
        </el-form-item>
        <el-form-item label="支付方式">
          {{ getPayTypeDescByPayType(checkItem.payType) || checkItem.payType }}
        </el-form-item>
        <el-form-item label="凭据" prop="icon" v-if="checkItem.payType == 5">
          <div style="
                  display: flex;
                  justify-items: center;
                  align-items: center;
                ">
            <el-image v-if="checkItem.file" style="width: 100px; height: 100px; margin-right: 10px" fit="scale-down"
              :src="checkItem.file">
            </el-image>
            <el-upload class="upload-demo" :before-upload="checkUpload" :http-request="upload" listType="picture-img"
              :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
              :on-exceed="handleExceed" :show-file-list="false" accept="image/jpg,image/jpeg,image/png">
              <el-button size="small">点击上传文件</el-button>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="支付方单据号" v-if="checkItem.payType != 5">
          <el-input v-model="checkItem.supplementPayNum" placeholder="输入支付方单据号" size="large"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :rows="4" :maxlength="100" resize="none" v-model="checkItem.supplementMark"
            size="large" placeholder="请输入备注" style="width: 320px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSupplement = false" size="small">取消</el-button>
        <el-button @click="applySupplement" size="small"
          type="primary">确认申请补单</el-button>
      </div>
    </el-dialog>

    <!-- 换绑记录弹窗 -->
    <el-dialog title="换绑记录" :visible.sync="showChangeMobileDialog" append-to-body width="40%">
      <el-table :data="checkItem.userChangeMobileRecords" border style="width: 100%">
        <el-table-column prop="oldMobile" label="原手机号"></el-table-column>
        <el-table-column prop="mobile" label="换绑手机号"></el-table-column>
        <el-table-column prop="createTime" label="换绑时间"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showChangeMobileDialog = false" size="small" type="primary">关闭</el-button>
      </div>
    </el-dialog>

  </basic-container>
</template>

<script>
import { orderList, getMerchantList, getPayTypeList, getBusinessTypeList, getRefundReasonTypeList, info, applyRefund, exportOrderList, supplement, getMtypeList, queryAllProductList, getSimpleChannelAllListBytid, refundRightInDoudian, iosApplyRefund } from '@/api/memberNew/order.js'
import { debounce, deepCopy } from '@/util/common'
import DynamicOption from "@/components/DynamicOption/index.vue";
import axios from "axios";
import Message from "@/components/Message";
import pagination from '@/util/mixins/pagination'
import { getLeboGoodsTypeOptions } from '@/api/financialManage/orderAllocationDetails'
import { goodsPageApi } from '@/api/goods_manage'
export default {
  mixins: [pagination],
  components: { DynamicOption },
  data() {
    return {
      payTime: [],
      orderNum: '', // 订单编号
      mobile: '', // 用户账户
      createTime: [],
      refundTime: [],
      payTypeList: [], // 支付方式列表
      payTypeParams: [], // 支付方式列表
      refundReasonTypeList: [], // 退款原因类型列表
      appids: [],
      mtypeIdParams: [],
      statusParams: [], // 订单状态（多选）
      supplementStatusParams: [], // 补单状态（多选）
      refundStatusParams: [], // 退款状态（多选）
      bussiTypeParams: [], // 业务类型（多选）
      businessTypeList: [],
      merchantList: [], // 商户列表
      merchantIdParams: [], // 收款商户类型（多选）
      goodsTypeFilterParams: [], // 商品类型（多选）
      orderTypeFilterParams: [], // 订单类型（多选）
      mtypeIds: "",
      productIdParams: [], // 产品id（多选）
      goodsIds: [], // 会员商品名称（多选，使用 value/index 作为值）
      goodsNameOptions: [], // 会员商品名称选项
      relatedMemberParams: [], // 关联联运会员（多选）
      remark: '', // 备注
      refundType: '2',
      refundPrice: 0,
      refundReason: "",
      refundReasonType: '1',
      setMemberType: "1",
      pageSize: 50,
      pageSizeArr: [10, 20, 30, 40, 50],
      checkItem: {}, // 查看项
      showDetails: false, // 详情弹窗
      showSupplement: false, // 补单弹窗
      showChangeMobileDialog: false, // 换绑记录弹窗
      tableId: "",  // 给默认值（即使是空字符串）
      tableData: [],
      channelList: [],
      serverTypeList: [],
      searchOptions: {
        // DynamicOption组件需要的参数，传递给getChannelsResource API
      },
      expireTimeOption: {
        disabledDate(time) {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate());
          return time >= tomorrow;
        }
      }
    }
  },
  created() {
    console.log(this.$route.query.orderNum)
    this.orderNum = this.$route.query.orderNum
    this.setPayTime()
    this.getList()
    this.fetchPayTypeList()
    this.fetchMerchantList()
    this.getBusinessTypeList()
    this.fetchRefundReasonTypeList()
    this.fetchMtypeList()
    this.fetchAllProductList()
    this.fetchSimpleChannelAllListBytid()
    this.getGoodsTypeOptions()
  },
  methods: {
    // 规范化结束日期为当日 23:59:59（若已含时分秒则不改）
    normalizeEndOfDay(dateStr) {
      if (!dateStr) return ''
      // 已包含时间则直接返回
      if (/\d{2}:\d{2}:\d{2}$/.test(dateStr)) return dateStr
      // 仅日期（yyyy-MM-dd）追加时间
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return `${dateStr} 23:59:59`
      return dateStr
    },
    // 查看订单明细
    checkDetail(id) {
      this.$store.dispatch('app/setOrder', id)
      this.$router.push('/member/order')
    },
    // 打开弹窗
    async openDetail(item, type) {
      // 两个对象元素相组合
      const detailData = await this.fetchInfo(item.id);
      console.log("查看项为"+JSON.stringify(detailData))
      this.checkItem = {...deepCopy(item),...detailData  }
      this.checkItem.detailType = type
      if (type === 1) {
        // 重置退款表单字段，避免上一笔订单的数据残留
        this.refundReason = ""
        this.refundReasonType = '1'
        this.refundType = '2'
        this.refundPrice = 0
        this.setMemberType = "1"
        this.showDetails = true
      } else if (type === 2) {
        this.showSupplement = true
      }else if(type === 3){
        this.fetchRefundRightInDoudian()
      }else if(type === 4){
        this.fetchIosRefund()
      }
      // 打印
      console.log(this.checkItem)
      // 处理checkItem
      if (this.checkItem.goodsType == 1 || this.checkItem.goodsType == 4) {
        if (this.checkItem.memberTimelineList) {
          this.checkItem.memberExpire = this.checkItem.memberTimelineList.map(v => v.startDate.substring(0, 10) + "至" + v.endDate.substring(0, 10)).join("，");
          this.checkItem.memberName = this.checkItem.serverTypeName;
          // 保留数值 maxRefundMoney，仅用于显示时拼文案
          this.checkItem.maxRefundMoneyText = "最大可退款金额：" + this.checkItem.maxRefundMoney + '元';
        } else if (this.checkItem.memberServer) {
          this.checkItem.memberExpire = "截止" + this.checkItem.memberServer.expireTime.substring(0, 10);
          this.checkItem.memberName = this.checkItem.memberServer.serverTypeName;
          this.checkItem.maxRefundMoneyText = "";
          this.checkItem.obversionNum = 0;
        }
      }
    },
    // 获取列表
    getList() {
      if (!this.checkTimeRange()) {
        return
      }
      this.listLoading = true
      let postData = {
        payStartTime: this.payTime && this.payTime[0] || '',
        payEndTime: this.normalizeEndOfDay(this.payTime && this.payTime[1] || ''),
        orderNum: this.orderNum || '',
        mobile: this.mobile,
        createStartTime: this.createTime && this.createTime[0] || '',
        createEndTime: this.normalizeEndOfDay(this.createTime && this.createTime[1] || ''),
        refundStartTime: this.refundTime && this.refundTime[0] || '',
        refundEndTime: this.normalizeEndOfDay(this.refundTime && this.refundTime[1] || ''),
        payTypes: this.payTypeParams.join(","),
        appids: this.appids.join(","),
        status: this.statusParams.join(","),
        supplementStatus: this.supplementStatusParams.join(","),
        refundStatus: this.refundStatusParams.join(","),
        bussiType: this.bussiTypeParams.join(","),
        merchantId: this.merchantIdParams.join(","),
        mtypeIds: this.mtypeIdParams.join(","),
        productId: this.productIdParams.join(","),
        orderTypeFilter: this.orderTypeFilterParams.join(","),
        goodsTypes: this.goodsTypeFilterParams.join(","),
        pids: this.getGoodsTypeId(this.goodsIds) || '',
        remark: this.remark || '',
        page: this.pageNo,
        limit: this.pageSize,
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.list
          this.totalCount = res.data.data.totalCount
          this.totalPage = res.data.data.totalPage
        } else {
          this.$message.error(res.data.msg)
        }
      }
      console.log("请求参数为" + postData)
      orderList(postData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    async fetchInfo(id) {
      try {
        const res = await info({ id });
        if (res.data.code === 200) {
          return res.data.data; // 直接返回数据
        } else {
          this.$message.error(res.data.msg);
          throw new Error(res.data.msg); // 抛出错误
        }
      } catch (error) {
        throw error;
      }
    },
    // 处理退款
    changeCheck: debounce(function (status) {
      // todo 参数校验
      if(status ==2){
        this.showDetails =false
      }
      else if (status == 3) {
        if (!this.refundPrice && status === 3) {
          this.$message.error('请输入退款金额')
          return
        }
        const pattern = /^[0-9]+(\.[0-9]{1,2})?$/;
        if (!pattern.test(this.refundPrice)) {
          this.$message.error('请输入正确的数字，小数最多两位');
          return;
        }
        // 退款金额上限校验：支付金额 + 折算金额
        const payAmount = Number(this.checkItem.payNum || 0)
        const obversionAmount = Number(this.getObversionNum(this.checkItem) || 0)
        if (Number(this.refundPrice) > payAmount + obversionAmount) {
          this.$message.error('退款金额不能大于订单支付金额+折算金额')
          return
        }
        // 退款理由长度校验（按旧版逻辑：中文100字=200长度）
        const realLen = (str => {
          if (!str) return 0
          let len = 0
          for (let i = 0; i < str.length; i++) {
            const code = str.charCodeAt(i)
            len += code >= 0 && code <= 128 ? 1 : 2
          }
          return len
        })(this.refundReason)
        if (realLen > 200) {
          this.$message.error('退款理由长度限制为100个中文字符')
          return
        }
        const payload = {
          id: String(this.checkItem.id),
          orderNum: this.checkItem.orderNum,
          serverCategoryType: this.checkItem.serverCategoryType || "",
          refundType: this.refundType,
          refundPrice: String(this.refundPrice) || "0",
          setMemberType: this.setMemberType,
          refundReasonType: this.refundReasonType,
          refundReason: this.refundReason,
        }
        if (this.setMemberType === '2') {
          payload.expireTime = this.checkItem.newExpireTime
        }
        applyRefund(payload).then(res => {
          this.listLoading = false
          if (res.data.code === 200) {
            this.showDetails = false
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    }, 300, false),

    // 导出
    exportList() {
      if (!this.checkTimeRange()) {
        return
      }
      let postData = {
        payStartTime: this.payTime && this.payTime[0] || '',
        payEndTime: this.normalizeEndOfDay(this.payTime && this.payTime[1] || ''),
        orderNum: this.orderNum || '',
        mobile: this.mobile,
        createStartTime: this.createTime && this.createTime[0] || '',
        createEndTime: this.normalizeEndOfDay(this.createTime && this.createTime[1] || ''),
        refundStartTime: this.refundTime && this.refundTime[0] || '',
        refundEndTime: this.normalizeEndOfDay(this.refundTime && this.refundTime[1] || ''),
        payTypes: this.payTypeParams.join(","),
        appids: this.appids.join(","),
        status: this.statusParams.join(","),
        supplementStatus: this.supplementStatusParams.join(","),
        refundStatus: this.refundStatusParams.join(","),
        bussiType: this.bussiTypeParams.join(","),
        merchantId: this.merchantIdParams.join(","),
        mtypeIds: this.mtypeIdParams.join(","),
        productId: this.productIdParams.join(","),
        orderTypeFilter: this.orderTypeFilterParams.join(","),
        goodsTypes: this.goodsTypeFilterParams.join(","),
        pids: this.getGoodsTypeId(this.goodsIds) || '',
        remark: this.remark || '',
      }
      exportOrderList(postData)
    },

    /** 获取支付类型描述 */
    async fetchPayTypeList() {
      const { data } = await getPayTypeList()
      console.log("🚀 ~ getPayTypeList ~ data:", data)
      this.payTypeList = data.data
      // 支付方式默认不选中
      // this.payTypeParams = data.data.map(item => item.dictKey)
    },
    /** 获取商户列表描述 */
    async fetchMerchantList() {
      const { data } = await getMerchantList()
      console.log("🚀 ~ getMerchantList ~ data:", data)
      this.merchantList = data.data
    },
    /** 获取业务类型描述 */
    async getBusinessTypeList() {
      const { data } = await getBusinessTypeList()
      console.log("🚀 ~ getBusinessTypeList ~ data:", data)
      this.businessTypeList = data.data
    },
    /** 获取渠道列表 */
    async fetchSimpleChannelAllListBytid() {
      const { data } = await getSimpleChannelAllListBytid()
      console.log("🚀 ~ getSimpleChannelAllListBytid ~ data:", data)
      this.channelList = data.data
    },
    getMerchantNameById(merchantId) {
      return this.merchantList.find(item => item.merchantId === merchantId)
    },
    getPayTypeDescByPayType(payType) {
      const matchedItem = this.payTypeList.find(item => item.dictKey === String(payType));
      return matchedItem ? matchedItem.dictValue : payType;
    },

    setCreateTime() {
      const end = new Date();
      // 设置结束时间为当天 23:59:59
      end.setHours(23, 59, 59, 0);
      const start = new Date();
      start.setDate(start.getDate() - 7);

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      const formatDateTime = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      };

      this.createTime = [formatDate(start), formatDateTime(end)];
    },

    setPayTime() {
      const end = new Date();
      // 设置结束时间为当天 23:59:59
      end.setHours(23, 59, 59, 0);
      const start = new Date();
      start.setDate(start.getDate() - 7);

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      const formatDateTime = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      };

      this.payTime = [formatDate(start), formatDateTime(end)];
    },

    // 获取商品类型描述，输入为 goodsType
    getGoodsTypeDesc(goodsType) {
      if (!goodsType || goodsType === 1) {
        return '会员服务';
      } else if (goodsType === 2) {
        return '旧版激活码';
      } else if (goodsType === 3) {
        return '新版激活码';
      } else if (goodsType === 4) {
        return '设备服务';
      } else {
        return goodsType;
      }
    },

    // 获取来源渠道，包括是否发送端，接收端，哪里的sdk/app
    getSourceChannel(row) {
      let channel = `[${row.appid}]${row.channelName}/`;
      if (row.terminalType === 1) {
        channel += '发送端/';
      } else {
        channel += '接收端/';
      }

      if (row.vipType === 0) {
        channel += '公版sdk';
      } else if (row.vipType === 1) {
        channel += '公版app';
      } else if (row.vipType === 2) {
        channel += '定制sdk';
      } else {
        channel += '定制app';
      }
      return channel;
    },
    getOrderStatusDesc(status) {
      if (status == 1) {
        return '支付成功';
      } else if (status == 0) {
        return '未支付';
      } else if (status == 3) {
        return '已作废';
      } else {
        return '支付失败';
      }
    },
    getGiveStatus(isgive) {
      if (isgive == null || isgive === 0) {
        return '购买';
      } else if (isgive === 1) {
        return '赠送';
      } else if (isgive === 2) {
        return '折算';
      }
      return isgive;
    },
    getRefundStatusDesc(refundStatus) {
      if (!refundStatus) {
        return '未申请';
      }
      const statusMap = {
        0: '未申请',
        1: '待处理',
        2: '退款失败',
        3: '已退款',
        4: '拒绝退款',
        5: '退款中'
      };
      return statusMap[refundStatus] || refundStatus;
    },
    // 获取补单状态描述，输入为包含 supplementStatus 的对象
    getSupplementStatusDesc(supplementStatus) {
      if (!supplementStatus) {
        return '未申请';
      }
      
      const statusMap = {
        0: '未申请',
        1: '待处理',
        2: '已补单',
        3: '已拒绝'
      };
      return statusMap[supplementStatus] || supplementStatus;
    },
    canShowRefundButton(row) {
      return (
        row.isVoid == 0 &&
        row.status == 1 &&
        (row.refundStatus == null || row.refundStatus == 0 || row.refundStatus == 4) &&
        ((row.payType == 0 && row.goodsType == 2) ||
          [0, 1, 2, 3, 4, 6, 7, 9, 10, 12, 13].includes(row.payType)) &&
        row.supplementStatus != 1 &&
        row.supplementStatus != 2
      );
    },
    // 三选一必填 + 各时间跨度独立 366 天校验
    checkTimeRange() {
      const hasCreate = this.createTime && this.createTime[0] && this.createTime[1]
      const hasPay = this.payTime && this.payTime[0] && this.payTime[1]
      const hasRefund = this.refundTime && this.refundTime[0] && this.refundTime[1]
      if (!hasCreate && !hasPay && !hasRefund) {
        this.$message.error('请至少选择创建时间、支付时间、退款时间中的一项')
        return false
      }
      const MAX_DAYS = 366 * 24 * 60 * 60 * 1000
      const checkSpan = (timeArr, label) => {
        if (timeArr && timeArr[0] && timeArr[1]) {
          const diff = new Date(timeArr[1]).getTime() - new Date(timeArr[0]).getTime()
          if (diff > MAX_DAYS) {
            this.$message.error(`${label}不能超过366天，请重新选择`)
            return false
          }
        }
        return true
      }
      if (!checkSpan(this.createTime, '创建时间')) return false
      if (!checkSpan(this.payTime, '支付时间')) return false
      if (!checkSpan(this.refundTime, '退款时间')) return false
      return true
    },
    disabledDate(time) {
      return time.getTime() > Date.now()
    },
    pickerOptions: {
      disabledDate(time) {
        return time.getTime() > Date.now();
      }
    },
    getObversionNum(checkItem) {
      if (checkItem.goodsType == 1 || checkItem.goodsType == 4) {
        if (checkItem.memberTimelineList) {
          return checkItem.obversionNum;
        } else if (checkItem.memberServer) {
          return 0;
        }
      }
      return ""
    },
    /** 获取退款原因类型描述 */
    async fetchRefundReasonTypeList() {
      const { data } = await getRefundReasonTypeList()
      console.log("🚀 ~ getRefundReasonTypeList ~ data:", data)
      this.refundReasonTypeList = data.data
    },
    /** 上传图片校验 */
    checkUpload(file) {
      console.log(file);
      // 判断类型
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        Message.error("请上传JPG、PNG格式文件");
        return false;
      }
      // 判断大小
      if (file.size > 1024 * 1024 * 5) {
        Message.error("文件大小不能超过5M");
        return false;
      }
    },
    /** 上传图片的方法 */
    async upload(params) {
      const file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      /** 正在上传图片 */
      // this.addFrom.icon = 'ing'
      try {
        const { data } = await axios.post(
          "/lebo-resource/oss/endpoint/put-file?code=lebotob",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        const result = data.data;
        console.log("上传补单凭证的响应", result);
        if (data.code === 200) {
          Message.success("上传成功");
        }
        /** 赋值会员图标 */
        this.checkItem.file = result.link;
        /** 强刷新数据 */
        this.$forceUpdate();
      } catch (error) {
        throw new Error(error);
      }
    },
    applySupplement() {
      if (this.checkItem.payType === 5) {
        if (!this.checkItem.file) {
          this.$message.error("凭据不能为空");
          return;
        }
      } else {
        const supplementPayNum = this.checkItem.supplementPayNum;
        if (!supplementPayNum) {
          this.$message.error("支付方单号不能为空");
          return;
        }
        if (supplementPayNum.length > 64) {
          this.$message.error("支付方单号长度限制为64个字符");
          return;
        }
      }

      const postData = {
        voucher: this.checkItem.file || "",
        id: String(this.checkItem.id),
        orderNum: this.checkItem.orderNum,
        payType: String(this.checkItem.payType),
        supplementMark: this.checkItem.supplementMark,
      }
      console.log('补单请求参数:', postData);
      // 此处可添加实际调用补单接口的代码
      supplement(postData).then(res => {
        if (res.data.code === 200) {
          this.$message.success('补单成功');
          this.checkItem.supplementStatus = 1;
        } else {
          this.$message.error(res.data.msg);
        }
        this.showSupplement = false
        this.getList()
      })
    },
    fetchMtypeList() {
      getMtypeList().then(res => {
        if (res.data.code === 200) {
          this.serverTypeList = res.data.data
        }
      })
    },
    fetchAllProductList() {
      queryAllProductList().then(res => {
        if (res.data.code === 200) {
          this.productList = res.data.data
        }
      })
    },
    fetchRefundRightInDoudian() {
      refundRightInDoudian({
        orderNum: this.checkItem.orderNum,
        refundType: 3,
        setMemberType: 1,
        expireTime: this.checkItem.expireTime
      }).then(res => {
        if (res.data.code === 200) {
          this.$message.success('申请成功');
        } else {
          this.$message.error(res.data.msg);
        }
      })
      this.getList()
    },
    fetchIosRefund() {
      // 弹窗 请确认线下已退款 确定按钮
      // 访问 member/order/iosApplyRefund 接口 附带orderNum post 请求
      this.$confirm('请确认线下已完成退款，是否继续？', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        return iosApplyRefund({ orderNum: this.checkItem.orderNum })
      }).then(res => {
        if (res && res.data && res.data.code === 200) {
          this.$message.success('操作成功');
          this.getList();
        } else if (res && res.data) {
          this.$message.error(res.data.msg || '操作失败');
        }
      }).catch(() => {
        // 用户取消或请求异常，不做处理
      })
    },
    copyTip() {
      Message.success("复制成功")
    },
    // 查询按钮
    searchAct() {
      this.pageNo = 1
      this.getList()
    },
    // 获取商品类型选项
    async getGoodsTypeOptions() {
      Promise.all([
        goodsPageApi({
          current: 1,
          size: 999,
        }),
        getLeboGoodsTypeOptions(),
      ]).then((res) => {
        console.log('获取商品类型:', res)
        const goodsPageOptions = res[0].data.data.records.map((item) => {
          return {
            id: item.id,
            label: `(${item.id}) ${item.goodsName}`,
          }
        })

        const goodsTypeOptions = res[1].data.data.map((item) => {
          return {
            id: item.id,
            label: `(${item.id}) ${item.goodsName}[旧]`,
          }
        })

        // 业务需要，将会员类型和商品类型合并，前端将两个数据合并后，再将index作为value
        this.goodsNameOptions = [...goodsPageOptions, ...goodsTypeOptions].map((item, index) => {
          return {
            ...item,
            value: index,
          }
        })
      }).catch((err) => {
        console.error('获取商品类型失败:', err)
        this.$message.error('获取商品类型失败')
      })
    },
    // 将商品名称的 value (index) 转换为实际的 id
    getGoodsTypeId(goodsIds) {
      if (!goodsIds || goodsIds.length === 0) return ''
      return goodsIds.map((item) => {
        const currentItem = this.goodsNameOptions.find((goodsNameItem) => item == goodsNameItem.value)
        return currentItem ? currentItem.id : ''
      }).filter(Boolean).join(',')
    },




  },
  watch: {
  '$route.query.orderNum'(newVal) {
    // 当路由中的 orderNum 变化时触发（如 this.$router.push 跳转）
    this.createTime =[]
    this.orderNum = newVal;
    this.getList(); // 重新加载数据
  }
}

}
</script>

<style lang="scss" scoped>
.search_group {
  margin-bottom: 20px;
}

.search_row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 10px;
  /* flex-wrap: wrap; */
}

.search_item {
  flex: 0.2;
  min-width: 0; /* 防止 flex 子元素溢出 */
  margin-right: 0;
}

.search_item:last-child {
  margin-right: 0;
}

.search_buttons {
  margin-left: 32px;
  flex: 0.6 !important;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0; /* 防止按钮被压缩 */
}

.search_buttons .el-button {
  margin-right: 0;
}

/* 确保所有输入框和选择框宽度一致 */
.search_item ::v-deep .el-input,
.search_item ::v-deep .el-select,
.search_item ::v-deep .el-date-editor {
  width: 100%;
}
.search_row ::v-deep .el-date-editor {
  padding: 0 !important;
  .el-range__icon {
    display: none !important;
  }
  .el-range__close-icon {
    line-height: 30px !important;
  }
} 
</style>
